import {
  formatDate,
  gridSize, gridSizeMdLg4,
  ModulosMotivoENUM,
  newEgresosSchema,
  ROUTER_PATHS, texto,
  useLoaders,
  useTableCoumnsEgresoInventarioSerie,
  useUploadFile
} from "@/shared";
import { useCreateEgresos, useFetchBodegas, useFetchMotivos } from "@/shared/actions/erp";
import { useFetchUnidadTransporte } from "@/shared/actions/erp/administration/unidad-transporte.actions";
import { CustomAutocomplete, CustomTextField, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";
import CustomCircularProgress from "@/shared/components/ui/Loaders/CustomCircularProgress";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { AlertSeverityEnum, EgresoForm, IDtaUnidadTransporte, MaterialTransferido } from "@/shared/interfaces";
import { BODEGAS, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Paper } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import ModalInventariableProductoFactor from "@/shared/components/ui/CargarSeries/ModalInventariableProductoFactor";
import ModalUbicacionProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalUbProductoSelectComponente";
import { toast } from "react-toastify";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import { IDataMotivo } from "@/shared/interfaces/erp/inventario/motivo.interface";
import { isAxiosError } from "axios";
import ModalProductosEnGestion, { ProductoEnGestion } from "./ModalProductosEnGestion";

type SaveEgresoProps = {
  title: string
}
export default function SaveEgresos({ title }: SaveEgresoProps) {
  const setAlert = useUiStore(s => s.setAlert)
  //*STORE
  const {
    columnsEgresoInventario
  } = useTableCoumnsEgresoInventarioSerie()
  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const { handleUploadFile } = useUploadFile();
  const handleAgregarUrlSerie = useCargarSeriesProductos(s => s.handleAgregarUrlSerie)
  const navigate = useNavigate()
  const isLoadingSeriesAll = useCargarSeriesProductos(s => s.isLoadingSeriesAll)


  //*STATE
  const [openLoading, setIsOpenLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [openConflictModal, setOpenConflictModal] = useState(false)
  const [productosEnGestion, setProductosEnGestion] = useState<ProductoEnGestion[]>([])
  const [conflictMessage, setConflictMessage] = useState("")
  //**form
  const form = useForm<EgresoForm>({
    resolver: yupResolver(newEgresosSchema as any)
  })
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = form;

  //**FETCH
  /* const {
    data: solicitudPedidoPaging,
    isLoading: isLoadingSolicitudPedido
  } = useFetchSolicitudesEgreso({
    page_size: 600,
    estado_solicitud: 'APROBADO'
  }); */
  const { data: dataUT, isLoading: isLoadingUT } = useFetchUnidadTransporte({ page_size: 100 });

  const {
    data: dataBodega,
    isLoading: isLoadingBodega,
  } = useFetchBodegas({ page_size: 600 })

  /* const {
    data: dataUbicacion,
    isLoading: isLoadingUbicacion,
  } = useFetchUbicaciones({
    page_size: 600,
    bodega: form.getValues().bodega
  }, !!form.watch('bodega')) */

  const crearEgreso = useCreateEgresos({})


  const {
    fetchAutocompleteUbicacion
  } = useAutocompleteFetch();
  //* onSave
  const onSave = (e: any) => {

    e.fecha_actual_fronted = dayjs().toISOString();

    if (productos.length === 0)
      return setAlert(true, 'No  has seleccionado ningun producto.', AlertSeverityEnum.error)

    const prod = productos.find(item => Number(item.cantidad) > item.producto_data?.stock_actual!)
    if (prod) {
      //setAlert(true, `La cantidad de ${prod.codigo} excede el stock disponible(${prod.producto_data?.stock_actual}).`, AlertSeverityEnum.error)
      return toast.error(`La cantidad de ${prod.producto_data?.descripcion} excede el stock disponible(${prod.producto_data?.stock_actual}).`)
    }


    for (let element of productos) {
      if (element.contiene_serie && element.series?.length == 0)
        return toast.error(`El producto ${element.producto_data?.descripcion} series pendientes por cargar`)
      if (element.contiene_serie && element.series?.length != element.cantidad)
        return toast.error(`El producto ${element.producto_data?.descripcion} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`)

    }
    
    setConfirmDialogIsOpen(true)
    setConfirmDialog({
      cancelTextBtn: 'Cancelar',
      isOpen: true,
      title: '¡Confirmar Egreso!',
      subtitle: '¿Estás seguro de continuar con el proceso de Egreso?. Esta acción es irreversible',
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {

        setIsOpenLoading(true);
        setMessage("Guardando tus datos... Espere un momento")

        const newProductoData = await handleAgregarUrlSerie(handleUploadFile)

        const obs = e.observacion_egreso?.trim()

        const egreso: any = {
          ...e,
          productos: newProductoData,
          fecha: formatDate(new Date),
          // observaciones: {
          //   // observacion_egreso: form.getValues().obeservacion_egreso ?? null
          //   observacion_egreso: obs?.trim() || null
          // }
          observaciones: obs ? {observacion_egreso : obs} : null,
        }
        try {
          const respEgreso = await crearEgreso.mutateAsync(egreso)

          if (respEgreso.code !== 200) return setIsOpenLoading(false)
          

          setConfirmDialogIsOpen(false)
          navigate(ROUTER_PATHS.inventario.egresos_nav)
          clearSelectedItems()


        } catch (error: any) {
          setIsOpenLoading(false)
          setConfirmDialogIsOpen(false)

          if (isAxiosError(error) && error.response?.status === 409) {
            const respData = error.response.data as any;
            setConflictMessage(respData?.message || "No se puede hacer un egreso por que existe productos en gestión");
            setProductosEnGestion(Array.isArray(respData?.data) ? respData.data : []);
            setOpenConflictModal(true);
          }
        }

      }
    })
  }

  //*limpieza
  useEffect(() => {
    return () => {
      reset()
      clearSelectedItems()
    }
  }, [])

  const bodega = form.watch('bodega')

  const ubicacionParams = useMemo(() => ({
    bodega
  }), [bodega])

  const {
    data: dataMotivos,
    isLoading: isLoadingMotivo
  } = useFetchMotivos({
    modulo: ModulosMotivoENUM.EGRESO_INVENTARIO
  });

  useLoaders(isLoadingSeriesAll)

  return (
    <>
      <SingleTableBoxScene
        title={title}
        visibleReport={false}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.egresos_nav}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Crear Egreso"
        iconCreateOrEdit={<TaskAltIcon />}
        fnCreateOrEdit={handleSubmit(onSave,
          () => { setAlert(true, texto.campo_obligatorio, AlertSeverityEnum.error) }
          /*  (errors) => {
             console.log(errors)
           } */
        )}
      >
        <Grid container spacing={2}>
          <CustomTextField
            disabled={true}
            control={control}
            name="fecha"
            defaultValue={new Date().toISOString().slice(0, 10) || ''}
            size={gridSizeMdLg4}
            label={"Fecha"}
            error={errors.fecha}
            helperText={errors.fecha?.message}
            onChangeValue={(e) => { form.setValue('fecha', dayjs(e).format('YYYY-MM-DD HH:mm:ss')) }}
          />
          <CustomAutocomplete<BODEGAS>
            label="Bodega"
            name="bodega"
            options={dataBodega?.data.data.filter(item => item.nombre !== "BODEGA EN TRANSITO") || []}
            valueKey="nombre"
            actualValueKey='codigo'
            defaultValue={form.getValues().bodega || ''}
            isLoadingData={isLoadingBodega}
            control={form.control}
            error={errors.bodega}
            helperText={errors.bodega?.message}
            onChangeValue={(e) => {
              if (e!)
                reset({ ...form.getValues(), ubicacion: undefined })
            }}
            size={gridSizeMdLg4}
          />
          {/* {form.getValues().bodega && (
            <CustomAutocomplete<Ubicaciones>
              label="Ubicación"
              name="ubicacion"
              options={dataUbicacion?.data.data || []}
              valueKey="nombre"
              actualValueKey='codigo'
              defaultValue={form.getValues().ubicacion || ''}
              isLoadingData={isLoadingUbicacion}
              control={form.control}
              error={errors.ubicacion}
              helperText={errors.ubicacion?.message}
              size={gridSizeMdLg4}
            />
          )} */}


          {form.getValues().bodega && (
            <CustomAutocompleteFetchForm<Ubicaciones>
              control={control}
              size={gridSizeMdLg4}
              name="ubicacion"
              label="Ubicación Origen"
              fetchParams={ubicacionParams}
              fetchData={fetchAutocompleteUbicacion}
              getOptionLabel={(opt) => opt.nombre || ''}
              key={'ubicacion'}
              getOptionKey={(o) => o.codigo}
              onChangeValue={(e) => {
                reset({
                  ...form.getValues(),
                  ubicacion: e as string ?? null
                })
              }}
            />
          )}

          <CustomAutocomplete<IDtaUnidadTransporte>
            required={false}
            size={gridSizeMdLg4}
            label={texto.unidad_transporte}
            name="unidad_transporte"
            options={dataUT?.data.data || []}
            valueKey="chofer_nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().unidad_transporte || ''}
            isLoadingData={isLoadingUT}
            control={control}
            error={errors.unidad_transporte}
            helperText={errors.unidad_transporte?.message}
          />


          <CustomAutocomplete<IDataMotivo>
            size={gridSizeMdLg4}
            label={texto.motivo}
            name="motivo"
            options={dataMotivos?.data.data || []}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().motivo || ''}
            isLoadingData={isLoadingMotivo}
            control={control}
            error={errors.motivo}
            helperText={errors.motivo?.message}
          />

          <CustomTextField
            required={false}
            control={control}
            name="observacion_egreso"
            defaultValue={form.getValues().observaciones?.observacion_egreso ?? ''}
            size={gridSizeMdLg4}
            label={"Observación"}
            error={errors.observaciones?.observacion_egreso}
            helperText={errors.observaciones?.observacion_egreso?.message}
          />

          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid container spacing={1} justifyContent={'space-between'} alignItems={'center'}>
                <Grid item>
                  <TabTextLabel text={'Items Seleccionado'} mt={0} pb={0} pl={0} pt={0} />
                </Grid>
                <Grid item xs={12} textAlign={'end'}>
                  <ModalUbicacionProductoSelectComponente
                    ubicacion={form.getValues().ubicacion!}
                    control={control}
                    onChange={(e) => {

                      console.log(e);

                      if (e.stock && +e.stock! <= 0)
                        return setAlert(true, `Producto con el codigo ${e.codigo} no tiene stock disponible.`, AlertSeverityEnum.warning);

                      const aux: MaterialTransferido = {
                        id: e.producto_data?.id_producto!,
                        codigo: e.codigo,
                        cantidad: 1,

                        contiene_serie: e.contiene_serie,
                        /*producto_data: {
                         codigo: e.codigo,
                         categoria_producto: e.categoria_producto,
                         subcategoria_producto: e.subcategoria_producto,
                         descripcion: e.descripcion,
                         stock_actual: e.stock_actual,
                         modelo_producto: e.modelo_producto,
                         marca_producto: e.marca_producto,
                         unidad_medida: e.unidad_medida
                       }, */
                        producto_data: {
                          ...e.producto_data!,
                          stock_actual: e.stock
                        },
                        usa_metros: e.usa_metros,
                        metros_actuales: e.metros_actuales,
                        ubicacion_origen: form.getValues().ubicacion,
                        series: [],
                      }

                      handleAgregarProducto(aux);
                    }}

                  />
                </Grid>

                {/* <Grid item xs={12} textAlign={'end'}>
                  <ModalProductoComponente
                    ubicacion={form.getValues().ubicacion!}
                    onChange={(e) => {

                      const aux: MaterialTransferido = {
                        id: e.id_producto!,
                        codigo: e.codigo,
                        cantidad: 1,
                        contiene_serie: false,
                        producto_data: {
                          codigo: e.codigo,
                          categoria_producto: e.categoria_producto,
                          subcategoria_producto: e.subcategoria_producto,
                          descripcion: e.descripcion,
                          stock_actual: e.stock_actual,
                          modelo_producto: e.modelo_producto,
                          marca_producto: e.marca_producto,
                          unidad_medida: e.unidad_medida
                        },
                        ubicacion_origen: form.getValues().ubicacion,
                        series: [],
                      }
                      handleAgregarProducto(aux)
                    }}
                  />
                </Grid> */}
                <div className="linea"></div>
                <Grid item xs={12}>
                  <SampleTablePagination
                    columns={columnsEgresoInventario}
                    data={paginatedData}
                    rowCount={productos.length}
                    setPagination={setPagination}
                    pagination={pagination}
                    rowNumber={true}
                  />
                </Grid>

              </Grid>
            </Paper>

          </Grid>
        </Grid>
      </SingleTableBoxScene>
      {/* <ModalProductoSeries
        generarSerie={false}
        seleccionarAutomatico={true}
        seleccionarManual={true}
        size={gridSizeMdLg3}
      /> */}

      <ModalInventariableProductoFactor
        generarSerie={false}
        seleccionarAutomatico={true}
        seleccionarManual={true}
        size={gridSizeMdLg4}
      />

      {
        openLoading && (
          <CustomCircularProgress open={openLoading} message={message}></CustomCircularProgress>
        )
      }

      <ModalProductosEnGestion
        open={openConflictModal}
        onClose={() => setOpenConflictModal(false)}
        productos={productosEnGestion}
        message={conflictMessage}
      />

    </>
  )
}
